<template>
  <h1>In Progress</h1>
</template>

<script>
export default {
  name: 'POSLookup',
  async created () {
  },
}
</script>

<style>

</style>
